/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useCallback, useEffect, useState } from 'react';

import Text from 'shared/components/Text';
import { getConstructorCategoriesStrings } from 'search/enums/translations';
import { useStoreSelector } from 'store/hooks/storeHooks';
import { snakeCase } from 'lodash/fp';
import { Checkbox } from './checkbox/Checkbox';
import Button from './button/Button';
import { CONDITION_DESCRIPTION, HEADER_NAMES } from '../product-grid/constant';
import { YearsFilter } from '../product-grid/YearsFilters';
import {
  colorsPalette,
  colorSwatch,
  getAllYears,
  getPricesFromRange,
  mergeColorsByName,
} from '../product-grid/utils/gridUtils';
import { Caret } from './icons/Caret';
import { PriceFilters } from '../product-grid/PriceFilters';

const getGridTemplateColumns = (headers: string[]) => {
  if (headers.length <= 1) return '1fr 16px';
  if (headers.length === 2) return '3fr 1fr 16px';
  if (headers.length === 3) return '2.5fr 1.5fr 1fr 16px';
};

const SUB_HEADERS = ['productTypesList', 'activitiesList'];
type IFilterKeys =
  | 'sortType'
  | 'priceList'
  | 'productCategoriesList'
  | 'productTypesList'
  | 'activitiesList'
  | 'colorsList'
  | 'releaseYearsList';
const Row = ({
  item,
  getItemFilterValue,
  headers,
  onClick,
  gridTemplate,
  filterKey,
  subIndex,
  currentSelection,
}: {
  item: any;
  onClick: (name: string, options: any) => void;
  headers: string[];
  gridTemplate?: string;
  filterKey: string;
  subIndex?: number;
  currentSelection?: any;
  getItemFilterValue?: (item: any) => string;
}) => {
  const { currentTheme } = useStoreSelector((state) => state.pageLayout);
  const isColor = filterKey === 'colorsList' && item.name;
  const [open, setOpen] = useState(false);
  const kidHeaderIndex = item[SUB_HEADERS[0]] ? 0 : item[SUB_HEADERS[1]] ? 1 : -1;

  if (isColor && !colorsPalette.includes(isColor.toLowerCase())) return null;
  return (
    <>
      <div
        className="tw-grid tw-items-center"
        style={{
          gridTemplateColumns: gridTemplate,
        }}
        data-qa={`${snakeCase(item.name).toLowerCase()}_option`}
      >
        {headers.map((header, i) => {
          const isCondition = header === 'name' && filterKey === 'productConditionsList';
          const isBrandLocation = header === 'location' && filterKey === 'brandsList';
          const isCount = header === 'count';
          const isCategory = filterKey === 'productCategoriesList' && header === 'count';

          return (
            // eslint-disable-next-line react/no-array-index-key
            <div className="tw-flex tw-items-center tw-gap-2" key={`${item.name}-row-${i}`}>
              {isColor && header === 'name' && (
                <div
                  className="tw-w-6 tw-h-6"
                  data-qa="filter_color_swatch"
                  style={{
                    backgroundColor: colorSwatch[isColor] || isColor,

                    backgroundImage:
                      isColor === 'multi-color'
                        ? 'url("https://cms-cdn.goat.com/750/567e15a619be-4918-ce11-49d1-06ca4b9e.png")'
                        : 'none',
                    backgroundSize: 'contain',
                  }}
                />
              )}
              {isCondition ? (
                <div>
                  <Text
                    className="first-letter:tw-uppercase tw-m-0"
                    data-qa="filter_conditions_title"
                  >
                    {getConstructorCategoriesStrings(
                      CONDITION_DESCRIPTION[item[header]].display_name,
                    )}
                  </Text>
                  <Text
                    className="first-letter:tw-uppercase tw-text-[9.5px] tw-tracking-[0] tw-m-0"
                    data-qa="filter_conditions_description"
                  >
                    {getConstructorCategoriesStrings(
                      CONDITION_DESCRIPTION[item[header]].data.description,
                    )}
                  </Text>
                </div>
              ) : (
                <Text
                  className="first-letter:tw-uppercase tw-m-0"
                  style={{
                    padding:
                      i === 0 && subIndex !== undefined && subIndex >= 0
                        ? `16px 0px 0px ${subIndex * 16 + 16}px`
                        : undefined,
                    paddingTop:
                      i >= 0 && subIndex !== undefined && subIndex >= 0 ? '16px' : undefined,
                  }}
                  data-qa={
                    isBrandLocation
                      ? 'brands_filter_location'
                      : isColor && header === 'name'
                        ? 'filter_color_name'
                        : isCategory
                          ? 'category_count'
                          : isCount
                            ? 'filter_option_count'
                            : undefined
                  }
                >
                  {item[header]}
                </Text>
              )}
            </div>
          );
        })}
        <div>
          {kidHeaderIndex < 0 ? (
            <Checkbox
              checked={
                currentSelection[filterKey]?.has(getItemFilterValue?.(item) as string) || false
              }
              id={item.name}
              name={item.name}
              onChange={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClick(item, { filterKey });
              }}
              style={{
                marginTop: subIndex !== undefined && subIndex >= 0 ? '16px' : undefined,
              }}
              color={currentTheme?.textColor || '#000'}
            />
          ) : (
            <div
              style={{
                paddingTop: subIndex !== undefined && subIndex >= 0 ? '16px' : undefined,
                paddingLeft: '4px',
              }}
            >
              <Caret direction={open ? 'up' : 'down'} onClick={() => setOpen((p) => !p)} />
            </div>
          )}
        </div>
      </div>
      {kidHeaderIndex >= 0 && open && (
        <div>
          <Row
            item={{
              name: `All ${item.name}`,
              count: item.count,
              originName: item.name,
            }}
            headers={headers}
            onClick={onClick}
            gridTemplate={gridTemplate}
            filterKey={
              kidHeaderIndex === 0
                ? 'productCategoriesList'
                : kidHeaderIndex === 1
                  ? 'productTypesList'
                  : filterKey
            }
            subIndex={kidHeaderIndex}
            currentSelection={currentSelection}
            getItemFilterValue={getItemFilterValue}
          />

          {item[SUB_HEADERS[kidHeaderIndex]].map((subItem: any, i: number) => {
            return (
              <Row
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                item={subItem}
                headers={headers}
                onClick={onClick}
                gridTemplate={gridTemplate}
                filterKey={
                  kidHeaderIndex === 0
                    ? 'productTypesList'
                    : kidHeaderIndex === 1
                      ? 'activitiesList'
                      : filterKey
                }
                subIndex={kidHeaderIndex}
                currentSelection={currentSelection}
                getItemFilterValue={getItemFilterValue}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

const getDataQa = (filterKey: string) => {
  if (filterKey === 'sorttype') {
    return 'sort';
  }
  if (filterKey === 'genderslist') {
    return 'gender';
  }
  if (filterKey === 'releaseyearslist') {
    return 'year';
  }
  return filterKey;
};

export const DropdownBody = ({
  data: filtersData,
  headers,
  closeDropdown,
  hideHeader = false,
  isMultiSelect,
  selectedItems,
  onSubmitSelection,
  getItemFilterValue,
  filterKey,
  hasSneakers,
  hasApparels,
}: {
  data: any;
  closeDropdown: () => void;
  headers: string[];
  filterKey: IFilterKeys;
  selectedItems: Record<string, Set<string>>;
  onSubmitSelection: (selection: any) => void;
  isMultiSelect?: boolean;
  getItemFilterValue?: (item: any) => string;
  hideHeader?: boolean;
  hasSneakers?: boolean;
  hasApparels?: boolean;
}) => {
  const [currentSelection, setCurrentSelection] = useState(selectedItems);
  const { currentTheme } = useStoreSelector((state) => state.pageLayout);

  let data = filtersData ? [...filtersData] : filtersData;

  if (filterKey === 'sortType' && data) {
    if (!hasSneakers) {
      data = data.filter((f) => f.key !== 'recently_released_sneakers');
    }
    if (!hasApparels) {
      data = data.filter((f) => f.key !== 'new_in_apparel');
    }
  }

  useEffect(() => {
    setCurrentSelection(selectedItems);
  }, [filterKey]);

  useEffect(() => {
    const handleDocumentClick = (event: any) => {
      if (!event.target.closest('.dropdown-body') && !event.target.closest('.dropdown-trigger')) {
        closeDropdown();
      }
    };

    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('touchend', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
      document.removeEventListener('touchend', handleDocumentClick);
    };
  }, []);

  const toggleSelection = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (item: any, { filterKey }: { filterKey: IFilterKeys }) => {
      const itemKeyValue = getItemFilterValue?.(item) || item.name;

      if (!isMultiSelect) {
        setCurrentSelection({
          ...currentSelection,
          [filterKey]: new Set([itemKeyValue]),
        });
      } else {
        const newSelection = new Set(currentSelection[filterKey]);

        if (newSelection.has(itemKeyValue)) {
          newSelection.delete(itemKeyValue);
        } else {
          newSelection.add(itemKeyValue);
        }
        setCurrentSelection({ ...currentSelection, [filterKey]: newSelection });
      }
    },
    [currentSelection, isMultiSelect],
  );

  const isColor = filterKey === 'colorsList';
  const isYear = filterKey === 'releaseYearsList';
  const isPrice = filterKey === 'priceList';

  if (isColor) {
    data = mergeColorsByName([...(data || [])]);
  }

  return (
    <div
      className="tw-border tw-border-solid"
      data-qa={`${getDataQa((HEADER_NAMES[filterKey]?.name || filterKey).toLowerCase())}_modal`}
      style={{
        backgroundColor: currentTheme?.backgroundColor || '#FFFFFF',
        borderColor: currentTheme?.borderColor || '#000',
      }}
    >
      {!hideHeader && !isYear && (
        <div
          className="tw-border-solid tw-border-b tw-border-x-0 tw-border-t-0"
          style={{
            padding: '16px 16px 8px',
            display: 'grid',
            fontSize: '9.5px',
            gridTemplateColumns: getGridTemplateColumns(headers),
          }}
          data-qa={`${(HEADER_NAMES[filterKey]?.name || filterKey).toLowerCase()}_modal_title`}
        >
          {headers.map((header, i) => {
            return (
              <Text
                key={header || i.toString()}
                className=" first-letter:tw-uppercase tw-m-0"
                style={{
                  color: currentTheme?.textColor || '#fff',
                }}
              >
                {HEADER_NAMES[filterKey]?.[header] || header}
              </Text>
            );
          })}
        </div>
      )}
      <div
        className="tw-p-4 tw-pt-0 tw-max-h-[340px] tw-overflow-y-auto"
        style={{
          paddingTop: isColor ? 16 : 0,
        }}
      >
        {isYear ? (
          <YearsFilter
            data={data}
            toggleSelection={(i: any) => toggleSelection(i, { filterKey })}
            setCurrentSelection={(rangeYears: any) =>
              setCurrentSelection({ [filterKey]: rangeYears })
            }
            currentSelection={currentSelection[filterKey] || new Set()}
          />
        ) : isPrice ? (
          <PriceFilters
            data={data}
            toggleSelection={(i: any) => toggleSelection(i, { filterKey })}
            setCurrentSelection={(rangeYears: any) =>
              setCurrentSelection({
                [filterKey]: new Set([`${rangeYears.start}-${rangeYears.end}`]),
              })
            }
            currentSelection={currentSelection[filterKey] || new Set()}
          />
        ) : (
          data.map((item: any, i: number) => {
            return (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                style={{
                  marginTop: isColor ? 0 : 16,
                }}
              >
                <Row
                  headers={headers}
                  item={item}
                  gridTemplate={getGridTemplateColumns(headers)}
                  onClick={toggleSelection}
                  filterKey={filterKey}
                  currentSelection={currentSelection}
                  getItemFilterValue={getItemFilterValue}
                />
              </div>
            );
          })
        )}
      </div>
      <div
        className="tw-border-solid tw-border tw-border-b-0 tw-border-x-0 tw-w-full tw-flex tw-justify-center"
        onClick={() => {
          if (filterKey === 'releaseYearsList') {
            onSubmitSelection({
              releaseYearsList: getAllYears(currentSelection.releaseYearsList),
            });
          } else if (filterKey === 'priceList') {
            onSubmitSelection({
              priceList: {
                priceMin: getPricesFromRange([...currentSelection.priceList][0] || '')?.start,
                priceMax: getPricesFromRange([...currentSelection.priceList][1] || '')?.end,
              },
            });
          } else {
            onSubmitSelection(currentSelection);
          }
        }}
      >
        <Button className="tw-w-full tw-h-full tw-p-[10px]">
          <Text
            className="tw-text-sm tw-m-0"
            data-qa={`${(HEADER_NAMES[filterKey]?.name || filterKey).toLowerCase()}_modal_select`}
          >
            SELECT
          </Text>
        </Button>
      </div>
    </div>
  );
};

export default DropdownBody;
